function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E7AB5"
    },
    d: "M8,11.568c-4.561,0-8-1.534-8-3.568s3.439-3.568,8-3.568S16,5.966,16,8S12.561,11.568,8,11.568z  M8,5.432C3.875,5.432,1,6.785,1,8s2.875,2.568,7,2.568S15,9.215,15,8S12.125,5.432,8,5.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E7AB5"
    },
    d: "M5.027,15L5.027,15c-0.35,0-0.668-0.081-0.947-0.242c-0.455-0.262-0.783-0.726-0.948-1.343 c-0.445-1.663,0.274-4.474,1.833-7.161C6.792,3.111,9.206,1,10.974,1c0.35,0,0.668,0.081,0.947,0.242 c0.454,0.261,0.782,0.725,0.947,1.341c0.445,1.664-0.274,4.475-1.834,7.162C9.21,12.888,6.796,15,5.027,15z M10.974,2 C9.82,2,7.625,3.667,5.83,6.757c-1.41,2.43-2.106,5.002-1.732,6.4c0.097,0.359,0.258,0.606,0.48,0.734 c0.971,0.558,3.526-1.09,5.591-4.649c1.411-2.431,2.107-5.003,1.733-6.401c-0.097-0.358-0.258-0.605-0.479-0.732 C11.295,2.036,11.148,2,10.974,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E7AB5"
    },
    d: "M10.974,15L10.974,15c-1.769,0-4.183-2.112-6.008-5.254C3.406,7.06,2.687,4.249,3.132,2.585 C3.297,1.968,3.625,1.503,4.08,1.242C4.359,1.081,4.678,1,5.027,1c1.768,0,4.182,2.112,6.007,5.256 c1.56,2.687,2.279,5.497,1.833,7.161c-0.165,0.617-0.492,1.081-0.946,1.341C11.642,14.919,11.323,15,10.974,15z M5.027,2 C4.853,2,4.706,2.036,4.578,2.109c-0.223,0.128-0.384,0.375-0.48,0.735c-0.374,1.398,0.322,3.97,1.733,6.4 C7.624,12.333,9.819,14,10.974,14l0,0c0.175,0,0.321-0.036,0.449-0.109c0.222-0.127,0.383-0.374,0.479-0.733 c0.375-1.398-0.321-3.97-1.732-6.4C8.376,3.667,6.181,2,5.027,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BB7F0"
    },
    d: "M9,8c0,0.553-0.447,1-1,1S7,8.553,7,8s0.447-1,1-1S9,7.447,9,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E7AB5"
    },
    d: "M8,9.5C7.173,9.5,6.5,8.827,6.5,8S7.173,6.5,8,6.5S9.5,7.173,9.5,8S8.827,9.5,8,9.5z M8,7.5 C7.725,7.5,7.5,7.724,7.5,8S7.725,8.5,8,8.5S8.5,8.276,8.5,8S8.275,7.5,8,7.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.369baa84cf50305ba647cae85771ff88.svg";
export { ForwardRef as ReactComponent };